export default __webpack_public_path__ + "static/media/checked-checkbox.c439a094.svg";